<div class="container" *ngIf="data">
  <ng-container *ngIf="!isProjectSynapseActive; else projectSynapseContent">
    <div class="header">
      <h2 id="sentence-info-title" tabindex="-1" #sentenceInfoTitle> {{(this.data.isExcluded && this.isOriginal ||
        this.translatedObj?.isExcluded && this.isTranslated? 'new_entries.excluded_sentence_information' :
        'report.sentence_information') | translate}}</h2>
      <button class="text-button" aria-label="Close" (click)="clearSentenceInformation()">X</button>
    </div>
    <div class="content">
      <div *ngIf="data.sentence || data.text" class="sentence-section">
        <h3>{{ 'report.sentence' | translate }}</h3>
        <p>{{ data.text }}</p>
        <div
          *ngIf="(this.analysisType == 'none' && this.isOriginal) || (this.analysisTy<pe !== 'none' && this.isOriginal) || (this.analysisType !== 'none' && !this.isOriginal)"
          style="padding-top: 4%; padding-bottom: 2%;">
          <h3 *ngIf="isTranslated">{{ 'new_entries.translated_sentence' | translate }}</h3>
          <p *ngIf="isTranslated">{{ this.translatedObj?.text }}</p>
        </div>
        <div role="tablist" aria-label="Sentence Information Tabs" class="buttons" *ngIf="analysisType === 'none'">
          <button *ngIf="data.isOriginal" role="tab" [attr.aria-selected]="isOriginal"
            [attr.aria-controls]="'original-panel'" class="btn language-btn" (click)="activeTab('original')"
            [ngClass]="{'activeOriginal': isOriginal}">
            <img src="./../../../../../assets/report_v2/original_language_icon.svg" alt="Original language">
            <p>{{ 'app.original_language' | translate }}</p>
          </button>
          <button *ngIf="data.isTranslated" role="tab" [attr.aria-selected]="isTranslated"
            [attr.aria-controls]="'translated-panel'" class="btn language-btn" (click)="activeTab('translated')"
            [ngClass]="{'activeTranslate': isTranslated}">
            <img src="./../../../../../assets/report_v2/translated_language_icon.svg" alt="Translated language">
            <p>{{ 'app.upload.translated_language' | translate }}</p>
          </button>
          <button *ngIf="data.isAi" role="tab" [attr.aria-selected]="isAi" [attr.aria-controls]="'ai-panel'"
            class="btn language-btn" (click)="activeTab('ai')" [ngClass]="{'activeAi': isAi}">
            <img src="./../../../../../assets/report_v2/authorship_border.svg" alt="Authorship">
            <p>{{ 'general.ai_authorship' | translate }}</p>
          </button>
          <button *ngIf="data.isManipulated.isManipulated" role="tab" [attr.aria-selected]="isManipulation"
            [attr.aria-controls]="'manipulation-panel'" class="btn language-btn" (click)="activeTab('manipulation')"
            [ngClass]="{'activeManipulation': isManipulation}">
            <img src="./../../../../../assets/report_v2/manipulations_icon.svg" alt="Manipulations">
            {{ 'new_entries.manipulations' | translate }}
          </button>
        </div>
      </div>
      <div class="similarity-section context-style" *ngIf="!isManipulation && !isAi && !isChangeSource">


        <ng-container
          *ngIf="(this.analysisType == 'none' && this.isOriginal) || (this.analysisType !== 'none' && this.isOriginal) || (this.analysisType !== 'none' && !this.isOriginal)">
          <div class="source">
            <h3 class="f16">{{ 'new_entries.matched_source' | translate }} <button
                *ngIf="(isOriginal && this.data.secondarySources && this.data.secondarySources.length > 0 && this.canEdit)"
                class="change_source_btn" (click)="changeSource()"><img
                  src="../../../../../assets/report_v2/refresh-double.svg">{{ 'report.change' | translate }}</button>
            </h3>
            <a *ngIf="source" [href]="source" target="_blank">{{ source }}</a>
            <a *ngIf="!source" target="_blank">{{ 'new_entries.private_document_source' | translate }}</a>
            <h3 class="f16">{{ 'new_entries.matched_sentence' | translate }}</h3>
            <p class="matched-text" tabindex="0" [innerHTML]="sentence" role="region"
              aria-label="Matched text with highlights">
            </p>
          </div>

          <p class="p_head">
            {{ 'new_entries.classification' | translate }}:
            <span [ngStyle]="{
                'background-color': getBgColor(data),
                'color': 'black',
                'padding': '3px',
                'font-weight': '500',
                'border-radius': '4px'
              }">{{ getClassificationText(data) }}
            </span>
          </p>

          <p class="p_head">{{ 'new_entries.sentence_similarity' | translate }}:
            <button class="tooltip_btn" matTooltipClass="new_report_tooltip reverse"
              matTooltip="Indicates the percentage of similarity between two sentences.">
              <img src="../../../../../assets/report_v2/info-empty.svg" alt="More  info on the sentence similarity" />
            </button>
            <span>{{ this.isOriginal ? data.similarity?.toFixed(2) : this.translatedObj?.source?.percentage?.toFixed(2)
              }}%</span>
          </p>

          <ng-container *ngIf="this.context_similarity">
            <p class="p_head"
              *ngIf="this.isOriginal ? data?.source?.contextSimilarity : this.translatedObj?.source.contextSimilarity">
              {{ 'new_entries.contextual_similarity' | translate }}:
              <button class="tooltip_btn" matTooltipClass="new_report_tooltip reverse"
                matTooltip="Shows the percentage of contextual similarity between two sentences.">
                <img src="../../../../../assets/report_v2/info-empty.svg"
                  alt="Shows the percentage of contextual similarity between two sentences." />
              </button>
              <span>{{ this.isOriginal ? data.source.contextSimilarityPercentage :
                this.translatedObj.source.contextSimilarityPercentage }}%</span>
            </p>
          </ng-container>
          <p class="p_head"
            *ngIf="this.isOriginal ? data.source?.averageDistance : this.translatedObj?.source?.averageDistance">
            {{ 'new_entries.proximity' | translate }}:
            <button class="tooltip_btn" matTooltipClass="new_report_tooltip reverse"
              matTooltip="Measures the average word distance between similar sentences.">
              <img src="../../../../../assets/report_v2/info-empty.svg" alt="More info on proximity" />
            </button>
            <span>{{ this.isOriginal ? data.source.averageDistance.toFixed(2) / 100 :
              this.translatedObj?.source?.averageDistance?.toFixed(2) / 100 }}</span>
          </p>

          <div class="sentence-info-container" *ngIf="data.sourceHistory && data.sourceHistory.length > 0">
            <div class="source-history-header" (click)="toggleSourceHistory()">
              <img [ngClass]="{'rotated': isSourceHistoryExpanded}"
                src="../../../../../assets/report_v2/up_down_arrow.svg" alt="Toggle source history" />
              <h3>{{ 'new_entries.view_removed_source' | translate }}: </h3>
              <button class="tooltip_btn" matTooltipClass="new_report_tooltip reverse"
                matTooltip="Source history displays a complete list of all other sources excluded from this sentence">
                <img src="../../../../../assets/report_v2/info-empty.svg"
                  alt="Source history displays a complete list of all other sources excluded from this sentence" />
              </button>
            </div>
            <div class="source-history-content" *ngIf="isSourceHistoryExpanded && data?.sourceHistory?.length">
              <ul>
                <li *ngFor="let source of data.sourceHistory">
                  <a *ngIf="source !== null" [href]="source" target="_blank" rel="noopener"
                    class="source-history-link">{{ source }}</a>
                  <span *ngIf="source === null" class="source-history-link">{{ 'new_entries.private_document_source' |
                    translate }}</span>
                </li>
              </ul>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="(this.analysisType == 'none' && !this.isOriginal &&  this.data.translated.length !== 0)">
          <div class="translationInfo">
            <div>
              <ng-container *ngFor="let obj of data.translated">
                <ng-container *ngIf="obj.lang === toggledLang">
                  <span *ngIf="!obj.isExcluded">
                    {{ 'new_entries.exclude_sentence' | translate }}
                  </span>
                  <span *ngIf="obj.isExcluded">
                    {{ 'new_entries.include_sentence' | translate }}
                  </span>
                </ng-container>
              </ng-container>
            </div>
            <div *ngFor="let language of this.data?.translated">
              <div [ngClass]="{'selectedTranslatedLanguage': language.lang == toggledLang}">
                <div class="row-container">
                  <div (click)="toggleRow(language.lang)" ngClass="translated_language_header">
                    <img src="../../../../../../assets/report_v2/up_down_arrow.svg" alt="up_down_arrow">
                    <span>{{this.languageService.getLanguageName(language?.lang)}}</span>
                  </div>
                  <!-- <button *ngIf="canEdit" aria-label="Remove Source" class="remove_source" [ngClass]="{'excluded': (language.isExcluded)}" (click)="isManipulation && data.isManipulated.isHiddenText ? toggleHiddenText(data.id) : isManipulation && data.isManipulated.isCharReplacement ? excludeCharacters() : excludeSentence(language?.lang)"><img src="../../../../../../assets/report_v2/delete-circled.svg" alt=""></button> -->
                </div>
                <div class="translationSentenceInfo">
                  <div *ngIf="toggledLang === language.lang" class="source translated_source">
                    <div>
                      <h3 class="f16">{{ 'new_entries.translated_sentence' | translate }}</h3>
                      <p>{{language.text}}</p>
                    </div>

                    <h3 class="f16">{{ 'new_entries.matched_source' | translate }}</h3>
                    <a *ngIf="language?.source?.url" [href]="language?.source?.url" target="_blank">{{
                      language.source.url }}</a>
                    <a *ngIf="!language?.source?.url" target="_blank">{{ 'new_entries.private_document_source' |
                      translate }}</a>
                    <h3 class="f16">{{ 'new_entries.matched_sentence' | translate }}</h3>
                    <p class="matched-text" [innerHTML]="language?.sentence" tabindex="0" role="region"
                      aria-label="Matched text with highlights">
                    </p>

                    <div class="clasificationsStyle">
                      <h3> {{ 'new_entries.classification' | translate }}:
                        <span [ngStyle]="{
                            'background-color': getBgColor(language),
                            'color': 'black',
                            'padding': '3px',
                            'font-weight': '500 !important',
                            'border-radius': '4px'
                          }">{{ getClassificationText(language) }}
                        </span>
                      </h3>

                      <h3>{{ 'new_entries.sentence_similarity' | translate }}:
                        <button class="tooltip_btn" matTooltipClass="new_report_tooltip reverse"
                          matTooltip="Indicates the percentage of similarity between two sentences.">
                          <img src="../../../../../assets/report_v2/info-empty.svg"
                            alt="Indicates the percentage of similarity between two sentences." />
                        </button>
                        <span class="fontBold-blue">{{ language?.source?.percentage.toFixed(2) }}%</span>
                      </h3>

                      <ng-container *ngIf="this.context_similarity">
                        <h3 *ngIf="language?.source?.contextSimilarity">
                          {{ 'new_entries.contextual_similarity' | translate }}:
                          <button class="tooltip_btn" matTooltipClass="new_report_tooltip reverse"
                            matTooltip="Shows the percentage of contextual similarity between two sentences.">
                            <img src="../../../../../assets/report_v2/info-empty.svg"
                              alt="Shows the percentage of contextual similarity between two sentences." />
                          </button>
                          <span class="fontBold-blue">{{ language?.source?.contextSimilarityPercentage}}%</span>
                        </h3>
                      </ng-container>

                      <h3 *ngIf="this.isOriginal ? data.source?.averageDistance : language?.source?.averageDistance">
                        {{ 'new_entries.proximity' | translate }}:
                        <button class="tooltip_btn" matTooltipClass="new_report_tooltip reverse"
                          matTooltip="Measures the average word distance between similar sentences.">
                          <img src="../../../../../assets/report_v2/info-empty.svg"
                            alt="Measures the average word distance between similar sentences." />
                        </button>
                        <span class="fontBold-blue">{{ this.isOriginal ? data.source.averageDistance.toFixed(2) / 100 :
                          language?.source?.averageDistance?.toFixed(2) / 100 }}</span>
                      </h3>
                    </div>

                    <!-- <button *ngIf="canEdit" (click)="excludeSentence(language?.lang)"  class="button-primary action_btn">{{ excludeButtonText }}</button> -->
                  </div>
                </div>
              </div>
            </div>
          </div>


        </ng-container>

      </div>



      <section class="remove_source" *ngIf="isChangeSource">
        <span tabindex="0" aria-label="Select a new source">{{ 'new_entries.select_new_source' | translate }}</span>
        <section class="sources">
          <ng-container *ngFor="let source of selectedSentenceSources">
            <section class="source" *ngIf="!source.isExcluded" tabindex="0" aria-label="Secondary Source.">
              <input (change)="onRadioChange(source.id)" type="radio" name="secondarySources" [id]="source.id">
              <label *ngIf="source.url" class="" [for]="source.id">{{ source.url }}</label>
              <label *ngIf="!source.url" class="" [for]="source.id">{{ 'new_entries.private_document_source' | translate
                }}</label>
            </section>
          </ng-container>
        </section>
      </section>


      <div class="similarity-section" *ngIf="isManipulation">
        <section class="manipulation_tabs"
          *ngIf="(this.data.isManipulated.isCharReplacement || this.data.isManipulated.isHiddenText) || (excludedCharReplacement && excludedHiddenText)">
          <section class="manipulation_tab" [ngClass]="{'active': isOnCharReplacement}"
            *ngIf="(this.data.isManipulated.isCharReplacement || excludedCharReplacement) && !(analysisType === 'manipulation' && manipulationType === 'hiddenText')"
            (click)="openManipulationTab('charReplacement')">{{ 'new_entries.character_replacement' | translate }}:
          </section>
          <section class="manipulation_tab" [ngClass]="{'active': isOnHiddenText}"
            *ngIf="(this.data.isManipulated.isHiddenText || excludedHiddenText) && !(analysisType === 'manipulation' && manipulationType === 'charReplacement')"
            (click)="openManipulationTab('hiddenText')">{{ 'new_entries.hidden_text' | translate }}:</section>
        </section>
        <section class="manipulation_tabs_body">
          <ng-container *ngIf="isOnCharReplacement">
            <p *ngIf="sentenceManipulation" class="matched-text" tabindex="0" [innerHTML]="sentenceManipulation"
              role="region" aria-label="Matched text with highlights"></p>
            <div *ngIf="!sentenceManipulation">
              <div class="includedChars">
                <h3>{{ 'new_entries.flags_found' | translate }}</h3>
                <ng-container *ngIf="data.manipulations[0]?.includedCharacters.length > 0; else noIncludedChars">
                  <!-- New "Select All" checkbox for included characters -->
                  <div class="select-all">
                    <span>{{ 'new_entries.select_all' | translate }}</span>
                    <input type="checkbox" class="custom-checkbox" [(ngModel)]="selectAllIncluded"
                      (change)="onSelectAllChange('included')" [disabled]="!isIncludedSelected" />
                  </div>
                  <div class="chars" *ngFor="let char of data.manipulations[0]?.includedCharacters; let i = index">
                    <p class="character-container">
                      <input type="checkbox" class="custom-checkbox" [(ngModel)]="selectionState[i]"
                        (change)="onCheckboxChange('included', i)" [disabled]="!isIncludedSelected"
                        style="display: block;" />
                      {{ 'new_entries.character' | translate }}:
                      <span class="bold">{{ char?.character}}</span>
                    </p>
                    <p class="appearance-container">{{ 'new_entries.appearance' | translate }}: <span class="bold">{{
                        char.count }}</span></p>
                  </div>
                </ng-container>
                <ng-template #noIncludedChars>
                  <p class="no_results_chars">{{ 'new_entries.no_excluded_characters' | translate }}</p>
                </ng-template>

                <h3>{{ 'new_entries.excluded_characters' | translate }}</h3>
                <ng-container
                  *ngIf="data.manipulations[0]?.excludedReplacedCharacters.length > 0; else noExcludedChars">
                  <!-- New "Select All" checkbox for excluded characters -->
                  <div class="select-all">
                    <span>{{ 'new_entries.select_all' | translate }}</span>
                    <input type="checkbox" class="custom-checkbox" [(ngModel)]="selectAllExcluded"
                      (change)="onSelectAllChange('excluded')" [disabled]="!isExcludedSelected" />
                  </div>
                  <div class="chars"
                    *ngFor="let char of data.manipulations[0]?.excludedReplacedCharacters; let i = index">
                    <p class="character-container">
                      <input type="checkbox" class="custom-checkbox" [(ngModel)]="excludedSelectionState[i]"
                        (change)="onCheckboxChange('excluded', i)" [disabled]="!isExcludedSelected"
                        style="display: block;" />
                      {{ 'new_entries.character' | translate }}:
                      <span class="bold">{{ char?.character}}</span>
                    </p>
                    <p class="appearance-container">{{ 'new_entries.appearance' | translate }}: <span class="bold">{{
                        char.count }}</span></p>
                  </div>
                </ng-container>
                <ng-template #noExcludedChars>
                  <p class="no_results_chars">{{ 'new_entries.no_included_characters' | translate }}</p>
                </ng-template>
              </div>
              <app-overview-disclaimer [title]="'general.overview' | translate" tabindex="0"
                disclaimerText="{{ 'new_entries.char_replacement_overview' | translate }}"></app-overview-disclaimer>
            </div>
            <!-- <div class="inside-modal" *ngIf="(data.isManipulated.isCharReplacement || excludedCharReplacement) && showInsideModal">
            <section class="parent" *ngIf="modalType == 'exclude'">
              <h1>{{ 'new_entries.exclude_characters' | translate }}</h1>
              <p>{{ 'new_entries.select_exclude_characters' | translate }}</p>
              <section class="modal-body">
                <div *ngIf="result.length > 0">
                  <label>
                    <input type="checkbox" (change)="toggleSelectAll($event)" />
                    <span>{{ 'new_entries.select_all' | translate }}</span>
                  </label>
                  <label>{{ 'new_entries.appearances' | translate }}</label>
                </div>
                <section class="scrollable">
                  <div *ngFor="let char of result; let i = index">
                    <label>
                      <input type="checkbox" [(ngModel)]="selectionState[i]" />
                      <span>{{ char?.character}}</span>
                    </label>
                    <label>{{ char?.count }}</label>
                  </div>
                  <p class="no_results" *ngIf="result.length == 0">{{ 'new_entries.no_excluded_characters' | translate }}!</p>
                </section>
              </section>
            </section>
            <section class="parent" *ngIf="modalType == 'include'">
              <h1>{{ 'new_entries.include_characters' | translate }}</h1>
              <p>{{ 'new_entries.select_include_characters' | translate }}</p>
              <section class="modal-body">
                <div *ngIf="excluded_result.length > 0">
                  <label>
                    <input type="checkbox" (change)="toggleSelectAll($event)" />
                    <span>{{ 'new_entries.select_all' | translate }}</span>
                  </label>
                  <label>{{ 'new_entries.appearances' | translate }}</label>
                </div>
                <section class="scrollable">
                  <div *ngFor="let char of excluded_result; let i = index">
                    <label>
                      <input type="checkbox" [(ngModel)]="excludedSelectionState[i]" />
                      <span>{{ char?.character}}</span>
                    </label>
                    <label>{{ char?.count }}</label>
                  </div>
                  <p class="no_results" *ngIf="excluded_result.length == 0">{{ 'new_entries.no_included_characters' | translate }}!</p>
                </section>
              </section>
            </section>
          </div> -->
          </ng-container>
          <ng-container *ngIf="isOnHiddenText">
            <!-- <div> -->
            <!-- <h3>{{ 'new_entries.hidden_text' | translate }}</h3> -->
            <p class="matched-text" tabindex="0" [innerHTML]="formattedText" role="region"
              aria-label="Matched text with highlights"></p>
            <!-- </div> -->
          </ng-container>
        </section>
      </div>
      <div class="similarity-section" *ngIf="isAi">
        <div class="aiContent">
          <img src="../../../../../assets/report_v2/warning-circled-filled-ai.svg" alt="Alert icon">
          <span>{{ 'new_entries.ai_generated_sentence_warning' | translate }}</span>
        </div>
        <app-overview-disclaimer [title]="'other.disclaimer' | translate"
          [disclaimerText]="'new_entries.ai_authorship_index_info' | translate"></app-overview-disclaimer>
      </div>
      <section class="exclude" *ngIf="showExclude && !isSourceExcluded()">
        <label for="exclusionReason">{{ 'new_entries.exclusion_reason_optional' | translate }}:</label>
        <section class="d-flex">
          <input #exclusionInput id="exclusionReason" type="text" class="commentInput"
            [class.has-edit-buttons]="isEditable " [(ngModel)]="commentValue" [disabled]="!isEditable || !canEdit"
            [attr.aria-label]="'new_entries.exclusion_reason_optional' | translate" />
          <div *ngIf="isEditable && showCommentButtons && canEdit" class="d-flex ml-10">
            <button tabindex="0" aria-label="Cancel Input" (click)="commentAction('discard')"
              [ngClass]="[!isEditable ? 'isEditableBtn' : '']" class="edit_input_btn cancel-btn">
              <img src="../../../../../assets/report_v2/close_big.svg" alt="">
            </button>
            <button tabindex="0" aria-label="Save Input" (click)="commentAction('update')"
              [ngClass]="[!isEditable ? 'isEditableBtn' : '']" class="edit_input_btn">
              <img src="../../../../../assets/report_v2/check.svg" alt="">
            </button>
          </div>
          <button *ngIf="!this.isEditable && canEdit" tabindex="0" aria-label="Edit the reason for exclusion"
            (click)="this.isEditable = true; this.showCommentButtons = true" class="edit_input_btn ml-10">
            <img src="../../../../../assets/report_v2/edit.svg" alt="">
          </button>
        </section>
      </section>

      <div class="footer" *ngIf="!isManipulation && canEdit && (this.isOriginal || this.isTranslated)">
        <button class="secondary-button"
          (click)="(excludeClickCount >=1 || includeClickCount >= 1) ? resetState() : clearSentenceInformation()">
          {{ ((excludeClickCount >=1 || includeClickCount >= 1) ? 'app.back' : 'general.close') | translate}}
        </button>
        <button class="button-primary" *ngIf="!this.isAi && !isChangeSource"
          [ngClass]="{'disabled': (this.isOriginal && this.data.source.isExcluded) || (this.isTranslated && this.translatedObj?.source?.isExcluded)}"
          (click)="excludeSentence()" [attr.aria-label]="excludeButtonAriaLabel">
          {{ excludeButtonText }}
        </button>
        <button class="tooltip_btn"
          *ngIf="(this.isOriginal && this.data.source.isExcluded) || (this.isTranslated && this.translatedObj?.source.isExcluded)"
          matTooltipClass="new_report_tooltip icon-aligned" [matTooltipPosition]="'above'"
          matTooltip="This sentence is excluded by source exclusion">
          <img src="../../../../../assets/report_v2/info-empty.svg"
            alt="This sentence is excluded by source exclusion" />
        </button>
        <button class="button-primary" *ngIf="changeSource && changeSourceClickCount >= 1" [disabled]="!selectedSource"
          [ngClass]="{'disabled': !selectedSource}" (click)="changeSource()">
          {{ 'report.change' | translate }}
        </button>
      </div>
      <div class="footer" *ngIf="isManipulation">
        <button class="secondary-button"
          (click)="((data.isManipulated.isCharReplacement && isManipulation) && (excludeClickCount >=1 || includeClickCount >= 1)) ? resetState() : clearSentenceInformation()">
          {{ (((data.isManipulated.isCharReplacement && isManipulation) && (excludeClickCount >=1 || includeClickCount
          >= 1)) ? 'app.back' : 'general.close') | translate }}
        </button>
        <ng-container *ngIf="isOnCharReplacement && canEdit">
          <button class="secondary-button" [disabled]="excludedSelectionIsDisabled()"
            [ngClass]="{'excluded disabled': excludedSelectionIsDisabled()}" (click)="includeCharacters()">
            {{ 'new_entries.include_characters' | translate }}
          </button>
          <button class="button-primary" [disabled]="selectionIsDisabled()"
            [ngClass]="{'excluded disabled': selectionIsDisabled()}" (click)="excludeCharacters()">
            {{ 'new_entries.exclude_characters' | translate }}
          </button>
        </ng-container>
        <ng-container *ngIf="isOnHiddenText && canEdit">
          <button class="button-primary" (click)="toggleHiddenText(data.id)" [attr.aria-label]="excludeButtonAriaLabel">
            {{ manipulationExcludeButtonText }}
          </button>
        </ng-container>
      </div>
    </div>
  </ng-container>
  <ng-template #projectSynapseContent>
    <div class="header project_synapse">
      <h2 id="sentence-info-title" tabindex="-1" #sentenceInfoTitle>Section Information</h2>
      <button class="text-button" aria-label="Close" (click)="clearSentenceInformation()">X</button>
    </div>
    <div class="project_synapse_content">
      <section class="sentences">
        <h3>
          Submitted Text
          <img class="info-icon" src="../../../../../assets/report_v2/info-empty.svg"
            alt="Information about submitted text">
        </h3>
        <p>{{data.original}}</p>
      </section>
      <section class="insights project_synapse">
        <section class="score">
          <h3 class="score_title">Similarity Score</h3>
          <img class="score_icon" src="../../../../../assets/report_v2/info-empty.svg" alt="Similarity Score"
            matTooltip="Indicates the level of similarity detected between the selected section and the corresponding section in the AI-simulated variant, with the classification depending on the chosen model"
            matTooltipPosition="above" matTooltipClass="new_report_tooltip">
          <p class="score_value">{{data.similarity_percentage}}%</p>
        </section>
        <section class="score">
          <h3 class="score_title">AI Detection</h3>
          <img class="score_icon" src="../../../../../assets/report_v2/info-empty.svg" alt="AI Detection"
            matTooltip="Indicates the likelihood of AI-generated content in the submission and provides a corresponding classification"
            matTooltipPosition="above" matTooltipClass="new_report_tooltip">
          <p class="score_value">{{data.ai_percentage}}%</p>
        </section>
        <section class="score stylometric" *ngIf="data.complete_percentage >= 30">
          <h3 class="score_title">Stylometric Discrepancy</h3>
          <img class="score_icon" src="../../../../../assets/report_v2/info-empty.svg" alt="Stylometric Discrepancy"
            matTooltip="Indicates the stylistic discrepancy between the selected section and the corresponding section in the AI-simulated variant, with the classification depending on the chosen model"
            matTooltipPosition="above" matTooltipClass="new_report_tooltip">
          <p class="score_value">{{ data.stylometrics.stylistic_discrepancy | titlecase }} Discrepancy</p>
          <section class="stylometric_table">
            <div class="stylometric-collapsible">
              <button class="stylometric-toggle" (click)="toggleStylometricTable()"
                [attr.aria-expanded]="isStylometricTableExpanded">
                <span>
                  {{ isStylometricTableExpanded ? 'Hide' : 'Show' }} Section Stylometrics
                  <button class="info-icon" aria-label="Information about Stylometric Table"
                    (click)="toggleStylometricTable()">
                    <img src="../../../../../assets/report_v2/info-empty.svg" alt="Information about Stylometric Table"
                      matTooltip="Compares the stylometrics of a section in the original submission with the stylometrics of the same section in the AI-simulated variant"
                      matTooltipPosition="above" matTooltipClass="new_report_tooltip">
                  </button>
                </span>
                <svg class="toggle-icon" [class.expanded]="isStylometricTableExpanded" width="14" height="8"
                  viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1 1L7 7L13 1" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round" />
                </svg>
              </button>

              <div class="stylometric-content" *ngIf="isStylometricTableExpanded">
                <!-- Tabs for different metric categories -->
                <div class="metrics-tabs" role="tablist" aria-label="Stylometric categories">
                  <button *ngFor="let category of stylometricCategories" class="metrics-tab" role="tab"
                    [attr.aria-selected]="selectedCategory === category.id"
                    [attr.aria-controls]="'tab-content-' + category.id" [id]="'tab-' + category.id"
                    [class.active]="selectedCategory === category.id" (click)="selectCategory(category.id)">
                    {{ category.name }}
                  </button>
                </div>

                <!-- Metrics Table -->
                <div class="metrics-table" role="table" aria-label="Stylometric Metrics Comparison">
                  <div class="table-header" role="row">
                    <div class="header-col metrics" role="columnheader">{{ ('stylometrics.metrics') | translate }}</div>
                    <div class="header-col" role="columnheader">AI Simulated</div>
                    <div class="header-col" role="columnheader">{{ ('stylometrics.current_submission') | translate }}
                    </div>
                  </div>
                  <div class="table-body">
                    <ng-container *ngIf="data?.stylometrics">
                      <div class="metric-row"
                        *ngFor="let metric of getMetricsForCategory(selectedCategory); let i = index" role="row">
                        <div class="metric-info" role="cell">
                          <div class="metric-name" [id]="'metric-name-' + i">
                            {{ ('stylometrics.' + selectedCategory + '.' + metric.name) | translate }}
                          </div>
                          <div class="metric-description" [attr.aria-labelledby]="'metric-name-' + i">
                            {{ ('stylometrics.' + selectedCategory + '.' + metric.name + '_description') | translate }}
                          </div>
                        </div>
                        <div class="metric-value" role="cell">
                          <div class="value-box ai-value"
                            [class.flagged-feature]="isFlaggedFeature(selectedCategory, metric.name)"
                            [attr.aria-label]="'AI generated value for ' + metric.name">
                            {{ getAIMetricValue(selectedCategory, metric.name) }}
                          </div>
                        </div>
                        <div class="metric-value" role="cell">
                          <div class="value-box original-value"
                            [class.flagged-feature]="isFlaggedFeature(selectedCategory, metric.name)"
                            [attr.aria-label]="'Original value for ' + metric.name">
                            {{ getOriginalMetricValue(selectedCategory, metric.name) }}
                          </div>
                        </div>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </section>
        <section class="ai-simulated">
          <h3 class="ai-simulated-title">
            AI Simulated text
            <img class="info-icon" src="../../../../../assets/report_v2/info-empty.svg"
              alt="Information about AI simulation"
              matTooltip="Represents the corresponding section simulated by the chosen AI model"
              matTooltipPosition="above" matTooltipClass="new_report_tooltip">
          </h3>

          <div class="model-selector">
            <label for="modelSelect">Select model for analysis</label>
            <select #modelSelect id="modelSelect" class="model-dropdown" (change)="onModelChange($event)"
              [attr.data-current-model]="currentAIModel">
              <option *ngFor="let model of availableAIModels" [value]="model.value"
                [attr.selected]="model.value === currentAIModel ? true : null">
                {{ formatAIModel(model.value) }}
              </option>
            </select>
          </div>

          <div class="simulated-text-container">
            <div class="simulated-text">
              <h4>Simulated Text</h4>
              <div [attr.data-refresh-key]="currentAIModel">
                <div *ngIf="data && data.ai_generated" style="white-space: pre-wrap; font-family: inherit;">
                  {{data.ai_generated}}
                </div>
                <div *ngIf="!data || !data.ai_generated" class="no-data">
                  No simulated text available for this model
                </div>
              </div>
            </div>
          </div>
        </section>
        <section class="score comparison_view">
          <h3 class="score_title">Side-by-side comparison</h3>
          <img class="score_icon" src="../../../../../assets/report_v2/info-empty.svg" alt="AI Detection"
            matTooltip="Toggle the side-by-side comparison of the submission and the AI-simulated variant"
            matTooltipPosition="above" matTooltipClass="new_report_tooltip">
          <button class="score_btn"
            (click)="isSideBySideVisible ? closeSideBySideComparison() : viewSideBySideComparison()">
            <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M4.75375 5.06866L2.36478 2.67969M2.36478 2.67969V4.59087M2.36478 2.67969H4.27596"
                stroke="#004080" stroke-width="0.860031" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M7.62054 5.06866L10.0095 2.67969M10.0095 2.67969V4.59087M10.0095 2.67969H8.09834"
                stroke="#004080" stroke-width="0.860031" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M4.75375 7.93524L2.36478 10.3242M2.36478 10.3242V8.41304M2.36478 10.3242H4.27596"
                stroke="#004080" stroke-width="0.860031" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M7.62054 7.93524L10.0095 10.3242M10.0095 10.3242V8.41304M10.0095 10.3242H8.09834"
                stroke="#004080" stroke-width="0.860031" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            {{ isSideBySideVisible ? 'Close Comparison' : 'View Comparison' }}
          </button>
        </section>
      </section>
    </div>
    <div class="project_synapse_footer">
      <button class="secondary-button" (click)="clearSentenceInformation()">
        {{ 'general.close' | translate }}
      </button>
      <button class="button-primary" (click)="toggleProjectSynapseSections()">
        {{ data.isExcluded ? 'Include Matching Selection' : 'Exclude Matching Selection' }}
      </button>
    </div>
  </ng-template>
</div>
